import { Box } from '@/components/Box/Box';
import { Button } from '@/components/Button/Button';
import { ButtonGroup } from '@/components/Button/ButtonGroup/ButtonGroup';
import { ModalWindow } from '@/components/ModalWindow/ModalWindow';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';
import MainLogo from '@/images/LogoSmall.svg?react';
import { NavigationLink } from '@/components/NavigationLink/NavigationLink';
import { ReactNode } from 'react';

type SubscriptionRequiredModalType = {
  isOpen: boolean;
  onConfirm: () => void;
  onClose: () => void;
  children: ReactNode;
};

export const SubscriptionRequiredModal = ({ isOpen, onConfirm, onClose, children }: SubscriptionRequiredModalType) => {
  return (
    <ModalWindow isOpen={isOpen} width='520px'>
      <Box display='flex' flexDirection='column' rowGap='28px'>
        <Box display='flex' flexDirection='column' rowGap='20px' alignItems='center'>
          <MainLogo width={200} height={40} />
          <Box display='flex' flexDirection='column' rowGap='12px' alignItems='center'>
            <Typography variant='headline4' color={COLORS.black} fontWeight='semibold'>
              Upgrade Required
            </Typography>

            <Box display='flex' flexDirection='column' rowGap='12px'>
              <Typography color={COLORS.grey[950]}>
                <b>Upgrade your subscription</b> to securely share and collect wire instructions.
                <br />
                <b>With a subscription, you can:</b>
              </Typography>
              <Box as='ul' margin='0' paddingLeft='30px'>
                {children}
              </Box>
              <Typography>Upgrade now to unlock full platform functionality.</Typography>
            </Box>
          </Box>
        </Box>

        <ButtonGroup mobileStretch gridTemplateColumns='0.4fr 0.6fr'>
          <Box display='flex' textAlign='center' alignItems='center'>
            <NavigationLink onClick={onClose} to='' width='100%' size='large'>
              Close
            </NavigationLink>
          </Box>
          <Button onClick={onConfirm}>Activate Subscription</Button>
        </ButtonGroup>
      </Box>
    </ModalWindow>
  );
};
